// @flow

export const REST_API_VERSION = '1.4.0';

export const X_API_VERSION = '2.0.0';

export default new class ApiVersioningHelper {
	getAdditionalRequestHeaders () {
		return {
			'x-api-version': X_API_VERSION,
		};
	}
};
